export class SupportingDocumentation {
    /**
     * Supporting Documentation class.
     *
     * @param {HTMLElement} container - The container element.
     */
    constructor(container) {
        this.container = container;
    }

    /**
     * Checks if the wrapper element has uploaded files.
     *
     * @returns {boolean} Whether the wrapper element has uploaded files.
     */
    get hasUploadedFiles() {
        return this.container.querySelector(`#file-list-${this.container.id}`).children.length > 0;
    }

    /**
     * Toggles the visibility of the wrapper element.
     *
     * @param {boolean} isVisible - The visibility of the wrapper element.
     */
    toggleVisibility(isVisible = true) {
        this.container.classList.toggle('d-none', !isVisible);
    }

    /**
     * Sets the description of the container element.
     *
     * @param {string} description - The description of the container element.
     */
    setDescription(description) {
        const descriptionElement = this.container.querySelector(`#file-description-${this.container.id}`);
        descriptionElement.textContent = description;
    }

    /**
     * Sets the required state of the container element.
     *
     * @param {boolean} isRequired - The required state of the container element.
     */
    setRequired(isRequired = true) {
        const fileUploadElement = this.container.querySelector(`#file-upload-${this.container.id}`);
        const fileDescriptionElement = this.container.querySelector(`#file-description-${this.container.id}`);

        fileUploadElement.required = isRequired;
        fileUploadElement.classList.toggle('is-invalid', isRequired);
        fileDescriptionElement.required = isRequired;
        fileDescriptionElement.classList.toggle('is-invalid', isRequired);
        if (isRequired) {
            fileDescriptionElement.setCustomValidity('You must click the "Add File" button to upload your proof of purchase.');
        } else {
            fileDescriptionElement.setCustomValidity('');
        }
    }
}